/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  AbstractRestService,
  identity,
  optimisticLockingOf,
  privilegedTokenOf,
  RestSettings,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { SystemVarsSalesDto } from './system-vars-sales.dto';
import { SystemVarsSalesMapper } from './system-vars-sales.mapper';

@Injectable()
export class SystemVarsSalesRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  get(): Observable<SystemVarsSalesDto> {
    return this.httpGet(`${this.bp}/system-variables/sale-settings`, optimisticLockingOf(SystemVarsSalesMapper));
  }

  getWebsiteLeads(): Observable<any> {
    return this.httpGet(`${this.bp}/system-variables/sale-settings/website-leads`, identity());
  }

  updateWebsiteLeads(list: any): Observable<any> {
    return this.httpPut(`${this.bp}/system-variables/sale-settings/website-leads`, list, identity());
  }

  update(sysVarsSales: SystemVarsSalesDto): Observable<SystemVarsSalesDto> {
    return this.httpPut(
      `${this.bp}/system-variables/sale-settings`,
      sysVarsSales,
      privilegedTokenOf(optimisticLockingOf(SystemVarsSalesMapper)));
  }
}
